import { Fragment } from 'react';
import { TMT_GAME_NAME, TMT_COGNITIVE_TAG, NODE_COLOR_CLASS } from '@/pages/tmt/tmtConfig';

interface GuideScreenProps {
  onStart: () => void;
}

const BASIC_ORDER = ['1', '가', '2', '나'];
const COND_ORDER = ['가', '나', '다'];

export default function GuideScreen({ onStart }: GuideScreenProps) {
  return (
    <div className="flex flex-col h-full px-6 pt-8 pb-6 animate-fade-in-up">
      {/* 제목 영역 */}
      <div className="text-center mb-5 shrink-0">
        <h1 className="text-2xl font-bold text-foreground-900 leading-tight">
          {TMT_GAME_NAME}
        </h1>
        <p className="text-sm font-medium text-primary-600 mt-1.5">#{TMT_COGNITIVE_TAG}</p>
      </div>

      {/* 안내 콘텐츠 카드 */}
      <div className="w-full flex-1 min-h-0 bg-white rounded-2xl border border-secondary-200 px-6 pt-6 pb-5 flex flex-col items-center justify-center">
        {/* 메인 안내 */}
        <p className="shrink-0 text-base font-semibold text-foreground-800 text-center leading-relaxed">
          주어진 조건을 확인하고
          <br />
          <strong className="font-bold">순서대로 빠르게</strong> 이어보세요!
        </p>

        {/* 기본 예시 */}
        <div className="shrink-0 mt-6 w-full flex flex-col items-center">
          <span className="text-xs font-bold text-foreground-500 px-2.5 py-1 rounded-full bg-secondary-100 whitespace-nowrap">
            기본
          </span>
          <div className="mt-3 flex items-center justify-center gap-1.5">
            {BASIC_ORDER.map((label, i) => (
              <Fragment key={label}>
                {i > 0 && (
                  <i className="ri-arrow-right-line text-primary-400 text-base leading-none" />
                )}
                <div className="w-11 h-11 rounded-full bg-primary-500 text-white flex items-center justify-center font-bold text-lg">
                  {label}
                </div>
              </Fragment>
            ))}
          </div>
        </div>

        {/* 조건 예시 */}
        <div className="shrink-0 mt-6 w-full flex flex-col items-center">
          <span className="text-xs font-bold text-foreground-500 px-2.5 py-1 rounded-full bg-secondary-100 whitespace-nowrap">
            조건이 있는 경우
          </span>
          <div className="mt-3 flex items-center justify-center gap-1.5">
            {COND_ORDER.map((label, i) => (
              <Fragment key={label}>
                {i > 0 && (
                  <i className="ri-arrow-right-line text-primary-400 text-base leading-none" />
                )}
                <div
                  className={`w-11 h-11 rounded-[8px] ${NODE_COLOR_CLASS.yellow} flex items-center justify-center font-bold text-lg`}
                >
                  {label}
                </div>
              </Fragment>
            ))}
          </div>
          <p className="mt-2 text-xs font-medium text-foreground-500 text-center whitespace-nowrap">
            노란색 네모 · 가 → 나 → 다
          </p>
        </div>

        {/* 드래그 힌트 */}
        <p className="shrink-0 mt-6 text-xs font-medium text-foreground-500 text-center whitespace-nowrap">
          노드를 누른 채 다음 노드까지 드래그해 이어보세요
        </p>
      </div>

      {/* 하단 버튼 */}
      <div className="w-full mt-5 pb-2 shrink-0">
        <button
          onClick={onStart}
          className="w-full py-4 px-6 rounded-2xl bg-white text-primary-700 font-semibold text-lg whitespace-nowrap
            border-2 border-primary-200
            active:scale-[0.98] transition-transform duration-150
            hover:bg-primary-50"
        >
          연습 시작
        </button>
      </div>
    </div>
  );
}